// extracted by mini-css-extract-plugin
module.exports = {"headerPolicy":"terms_headerPolicy__P7sHC","container":"terms_container__1-YjK"};